import EF from 'ef/ef';
import View from 'views/base/view';
import CourseMapView from './course-map-view';
import GuidesOverlayView from './guides-overlay-view';
import ToolbarTemplate from './templates/toolbar';
import IconLoadService from 'services/loader-handler-services/icon-load-service';
import $ from 'jquery';

const ToolBarView = View.extend({
  autoRender: true,
  autoAttach: true,
  className: 'col-md-12',
  template: ToolbarTemplate,
  regions: {
    achecker: 'achecker-report',
    course_map: '#course_map_pane',
  },
  initialize: function () {
    this.on('addedToDOM', function () {
      this.delegate('click', '#refresh_achecker', this.submitAChecker);
      this.delegate('click', '#guides-overlay-button', this.openGuidesOverlay);
      this.$('#accessibility').on('shown.bs.tab', () => this.submitAChecker());
      this.delegate('click', '.page-skipping-container .btn', this.setPageSkipping);
      this.delegate('click', '.tabs-header .tabs__tab-bar-button', e => {
        this.$el.find('.tabs-header .tabs__tab-bar-button').removeClass('tabs__tab-bar-button--active');
        $(e.currentTarget).addClass('tabs__tab-bar-button--active');
      });
      this.delegate('click', '.tabs.tab-vertical .tabs__tab-bar-button', e => {
        this.$el.find('.tabs.tab-vertical .tabs__tab-bar-button').removeClass('tabs__tab-bar-button--active');
        $(e.currentTarget).addClass('tabs__tab-bar-button--active');
      });
      IconLoadService.applyIcon('fal fa-times', '', 'fa-lg');
      const courseMap = new CourseMapView({
        collection: EF.modules,
        region: 'course_map',
      });
      this.subview('course_map', courseMap);
    });
    View.prototype.initialize.apply(this, arguments);
  },
  submitAChecker: function () {
    const html = `<!DOCTYPE>${document.documentElement.outerHTML}`;
    $('#achecker_html').val(html);
    $('#achecker_form').submit();
  },
  openGuidesOverlay: function () {
    const guidesOverlayView = new GuidesOverlayView();
    guidesOverlayView.render();
  },
  setPageSkipping(e) {
    EF.options.pageSkipping = e.currentTarget.querySelector('input').value === 'true';
    localStorage.setItem('pageSkipping', EF.options.pageSkipping);
  },
  getTemplateData() {
    return {
      pageSkipping: EF.options.pageSkipping,
    };
  },
});

export default ToolBarView;
